import React from 'react';
import './CombineScreen.css';
import { Box, Typography, Paper, Divider } from '@mui/material';

function CombineScreen({ consecutiveTrips }) {
  const getStationName = (stationId) => {
    const stationsMap = JSON.parse(localStorage.getItem('stationsMap')) || {};
    return stationsMap[stationId] || `Station ${stationId}`;
  };

  if (!consecutiveTrips || consecutiveTrips.length === 0) {
    return (
      <div className="combine-screen">
        <Box className="combine-placeholder">
          <Typography variant="h5" color="textSecondary" sx={{ textAlign: 'center' }}>
            Keine passenden Kombinationen gefunden
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mt: 1, textAlign: 'center' }}>
            Versuchen Sie es mit anderen Filtereinstellungen
          </Typography>
        </Box>
      </div>
    );
  }

  return (
    <div className="combine-screen">
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Gefundene Kombinationen ({consecutiveTrips.length})
        </Typography>
        
        {consecutiveTrips.map((tripSequence, index) => (
          <Paper key={index} sx={{ p: 2, mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              Kombination {index + 1}
            </Typography>
            
            {tripSequence.map((trip, tripIndex) => (
              <Box key={tripIndex}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>
                    {getStationName(trip.start_id)} → {getStationName(trip.end_id)}
                  </Typography>
                  <Typography color="textSecondary">
                    {new Date(trip.start_time).toLocaleDateString()} - 
                    {new Date(trip.end_time).toLocaleDateString()}
                  </Typography>
                </Box>
                {tripIndex < tripSequence.length - 1 && (
                  <Divider sx={{ my: 1 }} />
                )}
              </Box>
            ))}
          </Paper>
        ))}
      </Box>
    </div>
  );
}

export default CombineScreen; 